import React from 'react';

import Layout from '../layouts';
// import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
// import SocialLinks from '../components/SocialLinks';
// import Subscribe from '../components/Subscribe';
import EmailCTA from '../components/EmailCTA';


// import ipad from '../assets/images/ipad.png';
// import demoImage1 from '../assets/images/demo-image-01.jpg';
// import demoImage2 from '../assets/images/demo-image-02.jpg';
// import bgMaster from '../assets/images/bg-masthead.jpg';

// import { Link } from "gatsby"

const IndexPage = () => (
  <Layout hideChangeMode={true}>
    <header className="masthead">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center">
          <h1 className="mx-auto my-0 text-uppercase">{config.heading}</h1>
          <h2 className="text-white-50 mx-auto mt-2 mb-5">
            {config.subHeading}
            <br/>
            <br/>
            Currently in closed beta. Get into our waiting list below.
          </h2>
          <EmailCTA />
          {/* <Scroll type="id" element="about">
            <a href="" className="btn btn-primary">
              COMING SOON
            </a>
          </Scroll> */}
        </div>
      </div>
    </header>

    <section id="about" className="about-section text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4">
            Omnichannel.
            </h2>
            <p className="text-white-50">
              Iceberg isn't an app or a website.<br />We are a high quality source of news and industry coverage, obsessed with content experience and delivered everywhere.
            </p>
            <h2 className="text-white mb-4">
              Peaceful.
            </h2>
            <p className="text-white-50">
              Completely free of ads, auto-playing videos and other distractions.
            </p>
            <h2 className="text-white mb-4">
              Deep.
            </h2>
            <p className="text-white-50">
              Every sound coverage or analysis should be backed by data.<br/>Iceberg provides you with access to every single point of data, by giving access to our proprietary Data Analysis Platform, powered by state-of-the-art AI.
            </p>

          </div>
        </div>
        {/* <img src={ipad} className="img-fluid" alt="" /> */}
      </div>
    </section>


    {/* <section id="about" className="about-section-inv text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4">
            Omnichannel
            </h2>
            <p className="text-white-50">
              Iceberg isn't an app or a website. We are a high quality source of news and industry coverage obsessed to provide the best content consumption experience.
              <br /><br />
              Enough of those distracting ads. <br />Be peaceful while you read.
              <br /><br />
              No reading quota. <br />Freely satisfy your knowledge cravings.
            </p>
          </div>
        </div>
        <img src={ipad} className="img-fluid" alt="" />
      </div>
    </section> */}

     {/* <section id="projects" className="projects-section bg-light">
       <div className="container">
         <div className="row align-items-center no-gutters mb-4 mb-lg-5">
           <div className="col-xl-8 col-lg-7">
             <img className="img-fluid mb-3 mb-lg-0" src={bgMaster} alt="" />
           </div>
           <div className="col-xl-4 col-lg-5">
             <div className="featured-text text-center text-lg-left">
               <h4>Shoreline</h4>
               <p className="text-black-50 mb-0">
                 Grayscale is open source and MIT licensed. This means you can
                 use it for any project - even commercial projects! Download it,
                 customize it, and publish your website!
               </p>
             </div>
           </div>
         </div>

         <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
           <div className="col-lg-6">
             <img className="img-fluid" src={demoImage1} alt="" />
           </div>
           <div className="col-lg-6">
             <div className="bg-black text-center h-100 project">
               <div className="d-flex h-100">
                 <div className="project-text w-100 my-auto text-center text-lg-left">
                   <h4 className="text-white">Misty</h4>
                   <p className="mb-0 text-white-50">
                     An example of where you can put an image of a project, or
                     anything else, along with a description.
                   </p>
                   <hr className="d-none d-lg-block mb-0 ml-0" />
                 </div>
               </div>
             </div>
           </div>
         </div>

         <div className="row justify-content-center no-gutters">
           <div className="col-lg-6">
             <img className="img-fluid" src={demoImage2} alt="" />
           </div>
           <div className="col-lg-6 order-lg-first">
             <div className="bg-black text-center h-100 project">
               <div className="d-flex h-100">
                 <div className="project-text w-100 my-auto text-center text-lg-right">
                   <h4 className="text-white">Mountains</h4>
                   <p className="mb-0 text-white-50">
                     Another example of a project with its respective
                     description. These sections work well responsively as well,
                     try this theme on a small screen!
                   </p>
                   <hr className="d-none d-lg-block mb-0 mr-0" />
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </section> */}

    {/* <Subscribe /> */}
{/* 
    <SocialLinks /> */}
    <Footer />
  </Layout>
);

export default IndexPage;
